import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import MedicalInfo from "../../../components/PatientOnboard/MedicalInfo";
import UpdateFiles from "../../../components/PatientOnboard/UpdateFiles";
import OtherMedicalInfo from "../../../components/PatientOnboard/OtherMedicalInfo";
import * as Yup from "yup";
import PastMedications from "../../../components/PatientOnboard/PastMedications";
import BloodThinnerMedications from "../../../components/PatientOnboard/BloodThinnerMedications";
import currentPaintMedications from "../../../components/PatientOnboard/CurrentPainMedications";
import FormElementContainerNotExpanded from "../../../components/forms_builder/FormElementContainerNotExpanded";
import general_Medications from "../../../components/PatientOnboard/general_Medications";
import PhysicalExam from "../../../components/PatientOnboard/PhysicalExam";

const validationSchema = Yup.object().shape({
 /*   Recommendation_letter_use_cannabis:Yup.string().nullable().required('This field is mandatory'),
    Psychiatric_diagnosis:Yup.string().nullable().required('This field is mandatory'),
    Current_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Past_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Nuclear_family_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Drug_abuse:Yup.string().nullable().required('This field is mandatory'),
    Cardiovascular_history:Yup.string().nullable().required('This field is mandatory'),
    Cardiovascular_risk:Yup.string().nullable().required('This field is mandatory'),
    Lung_disease:Yup.string().nullable().required('This field is mandatory'),*/
    allergy_dye:Yup.string().nullable().required('This field is mandatory'),

})

class MedicalInfoTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


     componentWillMount() {
        this.props.initValidation(validationSchema)
    }

    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    onYesNoValueChange = (name,value) => {
        this.props.onYesNoValueChange(name,value)
    }
    onclickSetIsOtherMedicalDiagnosis = () => {
        this.props.onclickSetIsOtherMedicalDiagnosis()
    }
    onClickMedicationConditions = (value) => {
        this.props.onClickMedicationConditions(value)
    }
    onClickAddDeleteMedications = (index,event,id,type) => {
        this.props.onClickAddDeleteMedications(index,event,id,type)
    }
    addDeleteMedication = (func,index) => {
        this.props.addDeleteMedication(func,index)
    }
    onClickPatientAllergics = (event) => {
        this.props.onClickPatientAllergics(event)
    }

    render() {
        let {t} = this.props

        return (

            <div  className={'patientForm-box-container'}>
                <FormElementContainer title={t('patient_boarding.Medical_information')}
                                      Component={MedicalInfo}
                                      rest={{
                                          onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          onClickPatientAllergics:(val) =>this.onClickPatientAllergics(val),
                                          patient_allergics:this.props.patient_allergics,
                                          allergics:this.props.allergics,
                                          onClickMedicationConditions:(value) => this.onClickMedicationConditions(value) ,
                                          medicalConditions:this.props.medicalConditions,
                                          medicalConditionsSelected:this.props.medicalConditionsSelected,
                                          errors:this.props.errors,
                                          t:(e) => this.props.t(e)

                                      }}/>

                <FormElementContainer title={t('patient_boarding.current_medications')}
                                      Component={currentPaintMedications}
                                      rest={{
                                          onClickPatientAllergics:(val) =>this.onClickPatientAllergics(val),
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          currentPain_medications:this.props.currentPain_medications,
                                          patient_allergics:this.props.patient_allergics,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>

                <FormElementContainer title={t('patient_boarding.past_medications')}
                                      Component={PastMedications}
                                      rest={{
                                          onClickPatientAllergics:(val) =>this.onClickPatientAllergics(val),
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          past_med:this.props.past_med,
                                          isOtherPastUseMedication:this.props.isOtherPastUseMedication,
                                          patient_allergics:this.props.patient_allergics,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>

                <FormElementContainer title={t('patient_boarding.general_medications')}
                                      Component={general_Medications}
                                      rest={{
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          general_medications:this.props.general_medications,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>

                <FormElementContainer title={t('patient_boarding.Blood_thinners_Medications')}
                                      Component={BloodThinnerMedications}
                                      rest={{
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          bloodThinner_medications:this.props.bloodThinner_medications,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>

                                          <FormElementContainer title={t('patient_boarding.physical_examination')}
                                          Component={PhysicalExam}
                                          rest={{
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              entry:this.props.entry,
                                              errors:this.props.errors,
                                              t:(e) => this.props.t(e)

                                          }}/>
                <FormElementContainerNotExpanded title={t('patient_boarding.Other_Medical_information')}
                                          Component={OtherMedicalInfo}
                                          rest={{
                                              onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              entry:this.props.entry,
                                              psychiatric_diagnose_icd:this.props.psychiatric_diagnose_icd,
                                              errors:this.props.errors,
                                              t:(e) => this.props.t(e)

                                          }}/>


            </div>
        );
    }
}



const MedicalInfoTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(MedicalInfoTabComposed);

export default MedicalInfoTab;

